// extracted by mini-css-extract-plugin
export default {"title":"SettingsTitle_title__BlbbQ"};